import React from 'react';
import { Col, Row } from 'reactstrap';
import { displayValue } from './utils/quantityDeliveryUtils';

const PricingField = ({ label, children, md = 4 }) => (
  <Col md={md}>
    <div className='border-start border-2 border-primary ps-3'>
      <div className='text-muted small fw-semibold mb-1'>{label}</div>
      <div className='text-dark fs-14 fw-medium'>{children}</div>
    </div>
  </Col>
);

const QuantityPricingFields = ({
  parcel = {},
  showDeliveryUnit = true,
}) => (
  <>
    <Row className='g-3 mb-4'>
      {showDeliveryUnit && (
        <PricingField label='Delivery Unit' md={4}>
          {displayValue(parcel.deliveryUnit)}
        </PricingField>
      )}
      <PricingField
        label='Pricing Period'
        md={showDeliveryUnit ? 8 : 12}
      >
        {displayValue(parcel.pricingPeriodLabel)}
      </PricingField>
    </Row>

    <Row className='g-3 mb-4'>
      <PricingField label='Index Price Preference' md={4}>
        {displayValue(parcel.indexPrice)}
      </PricingField>
      <PricingField label='Other Index Price' md={4}>
        {displayValue(parcel.otherIndexPrice)}
      </PricingField>
      <PricingField
        label={parcel.pricingPeriodDetailLabel || 'Pricing Detail'}
        md={4}
      >
        {displayValue(parcel.pricingPeriodDetail)}
      </PricingField>
    </Row>

    <Row>
      <Col xs={12}>
        <div className='border-start border-2 border-primary ps-3'>
          <div className='text-muted small fw-semibold mb-2'>
            Notes for Pricing
          </div>
          {parcel.notesForPricing ? (
            <div className='html-content-panel'>
              <div
                className='html-content-body'
                dangerouslySetInnerHTML={{
                  __html: parcel.notesForPricing,
                }}
              />
            </div>
          ) : (
            <p className='text-dark fs-13 mb-0 lh-base'>-</p>
          )}
        </div>
      </Col>
    </Row>
  </>
);

export default QuantityPricingFields;
